__turbopack_context__.v({
  "container": "kQoZlW_container",
  "error": "kQoZlW_error",
  "message": "kQoZlW_message",
  "scale": "kQoZlW_scale",
  "scaleSection": "kQoZlW_scaleSection",
  "withError": "kQoZlW_withError",
});
